/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import { __awaiter } from "tslib";
import * as coreClient from "@azure/core-client";
import * as Mappers from "../models/mappers";
import * as Parameters from "../models/parameters";
import { LroEngine } from "@azure/core-lro";
import { LroImpl } from "../lroImpl";
/** Class containing Alias operations. */
export class AliasImpl {
    /**
     * Initialize a new instance of the class Alias class.
     * @param client Reference to the service client
     */
    constructor(client) {
        this.client = client;
    }
    /**
     * Create Alias Subscription.
     * @param aliasName AliasName is the name for the subscription creation request. Note that this is not
     *                  the same as subscription name and this doesn’t have any other lifecycle need beyond the request for
     *                  subscription creation.
     * @param body The parameters required to create a new subscription.
     * @param options The options parameters.
     */
    beginCreate(aliasName, body, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const directSendOperation = (args, spec) => __awaiter(this, void 0, void 0, function* () {
                return this.client.sendOperationRequest(args, spec);
            });
            const sendOperation = (args, spec) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                let currentRawResponse = undefined;
                const providedCallback = (_a = args.options) === null || _a === void 0 ? void 0 : _a.onResponse;
                const callback = (rawResponse, flatResponse) => {
                    currentRawResponse = rawResponse;
                    providedCallback === null || providedCallback === void 0 ? void 0 : providedCallback(rawResponse, flatResponse);
                };
                const updatedArgs = Object.assign(Object.assign({}, args), { options: Object.assign(Object.assign({}, args.options), { onResponse: callback }) });
                const flatResponse = yield directSendOperation(updatedArgs, spec);
                return {
                    flatResponse,
                    rawResponse: {
                        statusCode: currentRawResponse.status,
                        body: currentRawResponse.parsedBody,
                        headers: currentRawResponse.headers.toJSON()
                    }
                };
            });
            const lro = new LroImpl(sendOperation, { aliasName, body, options }, createOperationSpec);
            return new LroEngine(lro, {
                resumeFrom: options === null || options === void 0 ? void 0 : options.resumeFrom,
                intervalInMs: options === null || options === void 0 ? void 0 : options.updateIntervalInMs
            });
        });
    }
    /**
     * Create Alias Subscription.
     * @param aliasName AliasName is the name for the subscription creation request. Note that this is not
     *                  the same as subscription name and this doesn’t have any other lifecycle need beyond the request for
     *                  subscription creation.
     * @param body The parameters required to create a new subscription.
     * @param options The options parameters.
     */
    beginCreateAndWait(aliasName, body, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const poller = yield this.beginCreate(aliasName, body, options);
            return poller.pollUntilDone();
        });
    }
    /**
     * Get Alias Subscription.
     * @param aliasName AliasName is the name for the subscription creation request. Note that this is not
     *                  the same as subscription name and this doesn’t have any other lifecycle need beyond the request for
     *                  subscription creation.
     * @param options The options parameters.
     */
    get(aliasName, options) {
        return this.client.sendOperationRequest({ aliasName, options }, getOperationSpec);
    }
    /**
     * Delete Alias.
     * @param aliasName AliasName is the name for the subscription creation request. Note that this is not
     *                  the same as subscription name and this doesn’t have any other lifecycle need beyond the request for
     *                  subscription creation.
     * @param options The options parameters.
     */
    delete(aliasName, options) {
        return this.client.sendOperationRequest({ aliasName, options }, deleteOperationSpec);
    }
    /**
     * List Alias Subscription.
     * @param options The options parameters.
     */
    list(options) {
        return this.client.sendOperationRequest({ options }, listOperationSpec);
    }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);
const createOperationSpec = {
    path: "/providers/Microsoft.Subscription/aliases/{aliasName}",
    httpMethod: "PUT",
    responses: {
        200: {
            bodyMapper: Mappers.SubscriptionAliasResponse
        },
        201: {
            bodyMapper: Mappers.SubscriptionAliasResponse
        },
        202: {
            bodyMapper: Mappers.SubscriptionAliasResponse
        },
        204: {
            bodyMapper: Mappers.SubscriptionAliasResponse
        },
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    requestBody: Parameters.body2,
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host, Parameters.aliasName],
    headerParameters: [Parameters.accept, Parameters.contentType],
    mediaType: "json",
    serializer
};
const getOperationSpec = {
    path: "/providers/Microsoft.Subscription/aliases/{aliasName}",
    httpMethod: "GET",
    responses: {
        200: {
            bodyMapper: Mappers.SubscriptionAliasResponse
        },
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host, Parameters.aliasName],
    headerParameters: [Parameters.accept],
    serializer
};
const deleteOperationSpec = {
    path: "/providers/Microsoft.Subscription/aliases/{aliasName}",
    httpMethod: "DELETE",
    responses: {
        200: {},
        204: {},
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host, Parameters.aliasName],
    headerParameters: [Parameters.accept],
    serializer
};
const listOperationSpec = {
    path: "/providers/Microsoft.Subscription/aliases",
    httpMethod: "GET",
    responses: {
        200: {
            bodyMapper: Mappers.SubscriptionAliasListResult
        },
        default: {
            bodyMapper: Mappers.ErrorResponseBody
        }
    },
    queryParameters: [Parameters.apiVersion1],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept],
    serializer
};
//# sourceMappingURL=alias.js.map